import { graphql } from '@teachino/shared-infrastructure';

export const deleteItemsMutation = graphql(`
  mutation DeleteItems($multiTopicItemRemoveInput: MultiTopicItemRemoveInput!) {
    removeItems(multiTopicItemRemoveInput: $multiTopicItemRemoveInput) {
      done
    }
  }
`);
